import clsx from 'clsx';

import Button, { type ButtonProps } from './Button';
import s from './Button.module.scss';

const ButtonSmall = ({ className, ...props }: ButtonProps) => (
  <Button className={clsx(s.small, className)} {...props} />
);

export default ButtonSmall;
